import { render, staticRenderFns } from "./RequestItemPpe.vue?vue&type=template&id=9cb78f76&scoped=true&"
import script from "./RequestItemPpe.vue?vue&type=script&lang=js&"
export * from "./RequestItemPpe.vue?vue&type=script&lang=js&"
import style0 from "./RequestItemPpe.vue?vue&type=style&index=0&id=9cb78f76&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cb78f76",
  null
  
)

export default component.exports